import { render, staticRenderFns } from "./TriangleSmallDown.vue?vue&type=template&id=1eed3dd9"
import script from "./TriangleSmallDown.vue?vue&type=script&lang=js"
export * from "./TriangleSmallDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports